<h3>Uw {{ productName }}</h3>
<table class="table-data table-data--polis" *ngIf="purchasedProduct">
    <colgroup>
        <col width="33%" />
        <col width="33%" />
        <col width="33%" />
    </colgroup>
    <tbody>
        <tr>
            <td>Adres</td>
            <td>
                {{ purchasedProduct?.product?.home?.streetName }}
                {{ purchasedProduct?.product?.home?.civicNumber
                }}{{ purchasedProduct?.product?.home?.civicNumberSuffix }},
                <br />
                {{ purchasedProduct?.product?.home?.postalCode }}
                {{ purchasedProduct?.product?.home?.city }},
                {{ purchasedProduct?.product?.home?.countryDescription }}
            </td>
            <td></td>
        </tr>
    </tbody>
</table>
